var map = {
	"./ccgl.svg": 38800,
	"./crjls.svg": 27659,
	"./ddgl.svg": 98770,
	"./decj.svg": 18258,
	"./gpgl.svg": 10902,
	"./jksbgl.svg": 55915,
	"./navIcon1.svg": 39052,
	"./navIcon2.svg": 81921,
	"./navIcon3.svg": 30450,
	"./navIcon4.svg": 96738,
	"./navIcon5.svg": 62623,
	"./navIcon6.svg": 91005,
	"./navIcon7.svg": 66451,
	"./navIcon8.svg": 21781,
	"./newVipIcon1.svg": 16527,
	"./newVipIcon2.svg": 7229,
	"./newVipIcon3.svg": 95354,
	"./newVipIcon4.svg": 46810,
	"./newVipIcon5.svg": 24174,
	"./newVipIcon6.svg": 58195,
	"./newVipIcon7.svg": 87147,
	"./newVipIcon8.svg": 79232,
	"./qygl.svg": 92399,
	"./szls.svg": 87896,
	"./tjzx.svg": 14362,
	"./wlgl.svg": 60883,
	"./xxfb.svg": 22236,
	"./zhgl.svg": 52439,
	"./zjgl.svg": 81276
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42007;